<template>
  <RouterView
    :key="routerViewKey"
    v-slot="{ Component }"
  >
    <Transition
      appear
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <Component :is="Component" />
    </Transition>
  </RouterView>
</template>

<script>
import { storeToRefs } from "pinia";

import { useGlobalStore } from "shared/stores/global";

export default {
  name: "App",
  setup() {
    const globalStore = useGlobalStore();

    const { routerViewKey } = storeToRefs(globalStore);

    return {
      routerViewKey,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "shared/css/utils/transitions/slideRight";

.layout {
  width: 100%;
  transition: 0.3s;
}

.layout-wrapper {
  position: relative;
}

.player-popout-dragabble {
  border: none;
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 1;
}
</style>
